import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { setFileType } from '@/store/slices/uiSlice';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Badge } from '@/components/ui/badge';
import { FileText, Hash, ChevronDown, Filter } from 'lucide-react';

export function FileTypeFilter() {
  const dispatch = useAppDispatch();
  const { selectedType } = useAppSelector((state) => state.ui.fileFilters);

  const typeOptions = [
    { value: 'all', label: 'All Files', icon: Filter },
    { value: 'document', label: 'Documents', icon: FileText },
    { value: 'phrase', label: 'Phrases', icon: Hash },
  ] as const;

  const currentType = typeOptions.find((option) => option.value === selectedType);
  const CurrentIcon = currentType?.icon || Filter;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-2">
          <CurrentIcon className="h-3 w-3" />
          <span className="hidden sm:inline">{currentType?.label}</span>
          {selectedType !== 'all' && (
            <Badge variant="secondary" className="ml-1 h-4 px-1 text-xs">
              1
            </Badge>
          )}
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {typeOptions.map((option) => {
          const Icon = option.icon;
          return (
            <DropdownMenuItem
              key={option.value}
              onClick={() => dispatch(setFileType(option.value))}
              className="flex items-center gap-2"
            >
              <Icon className="h-4 w-4" />
              <span>{option.label}</span>
              {selectedType === option.value && (
                <Badge variant="secondary" className="ml-auto text-xs">
                  ✓
                </Badge>
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
